import * as React from "react";
const SvgFiRrHatWitch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-witch_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-.681L17.074 7.81A1.365 1.365 0 0 1 18.365 6h3.977c.693 0 1.301-.418 1.547-1.067a1.64 1.64 0 0 0-.533-1.895l-2.112-1.495a1 1 0 0 0-.086-.055C19.309.445 17.718 0 15.839 0h-.927a8 8 0 0 0-7.57 5.415L1.677 22H1a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2m-9 0h-4v-1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5zm2 0v-1.5c0-1.378-1.122-2.5-2.5-2.5h-3A2.503 2.503 0 0 0 8 20.5V22H3.791L9.234 6.061A6 6 0 0 1 14.912 2h.927c1.497 0 2.783.361 4.293 1.205L21.255 4h-2.889c-1.101 0-2.134.54-2.763 1.444a3.39 3.39 0 0 0-.413 3.038l4.996 13.519h-4.187z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-witch_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatWitch;
